// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — RackCall.styled.classic.js, новая — RackCall.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './RackCall.styled.classic';
import * as cp from './RackCall.styled.cp';

export const ButtonBlock = isCp ? cp.ButtonBlock : classic.ButtonBlock;
export const CallBadge = isCp ? cp.CallBadge : undefined;
export const CallBlock = isCp ? cp.CallBlock : classic.CallBlock;
export const CallIcon = isCp ? cp.CallIcon : classic.CallIcon;
export const CallIndicator = isCp ? cp.CallIndicator : classic.CallIndicator;
export const CallWaves = isCp ? cp.CallWaves : undefined;
export const Content = isCp ? cp.Content : classic.Content;
